import { InvitationsTab } from "@/components/my/Invitations";
import { ScheduleTab, HistoryTab, AvailabilityTab } from "@/components/my/Schedule";
import { PerksTab } from "@/components/my/Perks";
import { ProfileTab, TrainingTab, DocumentsTab } from "@/components/my/Personal";

export const MY_TABS = [
  { key: "profile", label: "My profile", Component: ProfileTab },
  { key: "schedule", label: "My schedule", Component: ScheduleTab },
  { key: "work", label: "Invitations & engagements", Component: InvitationsTab },
  { key: "availability", label: "Availability", Component: AvailabilityTab },
  { key: "history", label: "Timesheets & history", Component: HistoryTab },
  { key: "training", label: "Training & qualifications", Component: TrainingTab },
  { key: "documents", label: "Documents", Component: DocumentsTab },
  { key: "perks", label: "My Perks", Component: PerksTab },
];
